import { render } from "./Toolbar.vue?vue&type=template&id=2512b1c8&scoped=true"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=2512b1c8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2512b1c8"]])

export default __exports__